import { LoadingPage } from '@pangea-lis-apps/ui';

interface CallbackProps {}

export function Callback(props: CallbackProps) {
	return <LoadingPage />;
}

export default Callback;
